import { apiSortOptions } from "./sort";

export const ALL = "all_times";
export const DATE_RANGE = "date_range";
export const THIS_WEEK = "this_week";
export const THIS_MONTH = "this_month";
export const LAST_WEEK = "last_week";
export const LAST_MONTH = "last_month";
export const NEXT_WEEK = "next_week";
export const NEXT_MONTH = "next_month";
export const THIS_YEAR = "this_year";
export const NEXT_12_MONTHS = "next_12_months";
export const NEXT_CALENDAR_YEAR = "next_calendar_year";
export const PREVIOUS_YEAR = "previous_year";

export const ADMIN_DATE_FILTER_ID = "Admin_Date_Filter_All_Cycles";
export const ADMIN_DATE_FILTER_THIS_YEAR_ID = "Admin_Date_Filter_All_Cycles_This_Year";
export const ADMIN_DATE_FILTER_NEXT_12_MONTHS_ID = "Admin_Date_Filter_All_Cycles_Next_12_Months";
export const ADMIN_DATE_FILTER_NEXT_CALENDAR_YEAR_ID = "Admin_Date_Filter_All_Cycles_Next_Calendar_Year";
export const ADMIN_DATE_FILTER_PREVIOUS_YEAR_ID = "Admin_Date_Filter_All_Cycles_Previous_Year";
export const ADMIN_DATE_FILTER_ALL_CYCLES_ID = "Admin_Date_Filter_All_Cycles_All_Cycles";
export const ADMIN_DATE_FILTER_CUSTOM_ID = "Admin_Date_Filter_All_Cycles_Custom";

export const ADMIN_FIELD = "administrationDate";
export const UNASSIGNED = "Unassigned";
export const ALL_ASSIGNEES = "all_assignees";
export const FILTER_PATIENT_ASSIGNEE = "assignee-filter";

const THIS_MONTH_FILTER = { fromDate: THIS_MONTH, toDate: null };

export const ORDER_VIEW = Object.freeze({
  ALL_ORDERS: { title: "All Orders", value: "all_orders" },
  CURRENT_ORDER: { title: "Current Orders", value: "current_order" }
});

export const defaultFilters = {
  isOpen: false,
  statusesFilter: [],
  physiciansFilter: [],
  facilitiesFilter: [],
  manufacturersFilter: [],
  assigneesFilter: [],
  orderDateFilter: THIS_MONTH_FILTER,
  adminDateFilter: { fromDate: ALL, toDate: null },
  estimatedDeliveryDateFilter: { fromDate: ALL, toDate: null },
  receivedDateFilter: { fromDate: ALL, toDate: null },
  showInactiveFilter: "false",
  drugsFilter: [],
  drugDoseFormCategoriesFilter: [],
  orderTypesFilter: [],
  billVoidedFilter: [],
  billVoidedDateFilter: { fromDate: ALL, toDate: null },
  orderViewFilter: ORDER_VIEW.CURRENT_ORDER.value,
  forceCallApi: false,
  isUnassigned: false
};

export const defaultMultiples = {
  assigneesFilter: [],
  statusesFilter: [],
  orderTypesFilter: [],
  physiciansFilter: [],
  facilitiesFilter: [],
  manufacturersFilter: [],
  drugsFilter: []
};

export const NOT_DONE = null;
export const DONE = "checked";

export const defaultTaskFilters = {
  timeRange: { fromDate: ALL, toDate: null },
  assigneesFilter: [],
  status: NOT_DONE,
  isAssigneesFilterModified: false
};

export const BILL_VOIDED = Object.freeze({
  YES: { title: "Yes", value: true },
  NO: { title: "No", value: false }
});

export const ORDER_TYPES = Object.freeze({
  FREE: { title: "Free", value: "free" },
  REPLACEMENT: { title: "Replacement", value: "replacement" }
});

export const defaultSavedListFilters = Object.freeze({
  query: "",
  limit: 10,
  skip: 0,
  orderBy: "updatedAt",
  filterBy: "all",
  sortBy: "DESC",
  selectedView: "pharmacy-list"
});

export const defaultSavedListSorting = {
  all: { name: apiSortOptions.desc, updatedAt: apiSortOptions.desc, orderBy: defaultSavedListFilters.orderBy },
  private: { name: apiSortOptions.desc, updatedAt: apiSortOptions.desc, orderBy: defaultSavedListFilters.orderBy },
  starred: { name: apiSortOptions.desc, updatedAt: apiSortOptions.desc, orderBy: defaultSavedListFilters.orderBy },
  shared: { name: apiSortOptions.desc, updatedAt: apiSortOptions.desc, orderBy: defaultSavedListFilters.orderBy }
};
